
export default {
  vessel: {
    link: {
      $attrs: 'all',
      display: 'block'
    }
  }
}
